/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 電解槽情報（入力情報）
 * @export
 * @interface ElectrolyzerInput
 */
export interface ElectrolyzerInput {
    /**
     * No.
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    no?: number;
    /**
     * 電解槽名
     * @type {string}
     * @memberof ElectrolyzerInput
     */
    electrolyzer?: string;
    /**
     * 稼働/停止
     * @type {string}
     * @memberof ElectrolyzerInput
     */
    operate?: string;
    /**
     * 対数（ついすう）
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    cells?: number;
    /**
     * 電流
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    current?: number;
    /**
     * 電圧
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    voltage?: number;
    /**
     * 苛性温度
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    temp?: number;
    /**
     * 電流効率
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    currentEfficiency?: number;
    /**
     * 最大電流
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    rangeMax?: number;
    /**
     * 最小電流
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    rangeMin?: number;
    /**
     * 苛性生産量
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    naohProduction?: number;
    /**
     * 苛性中食塩濃度
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    naclInNaoh50?: number;
    /**
     * PC
     * @type {number}
     * @memberof ElectrolyzerInput
     */
    pc?: number;
}

/**
 * Check if a given object implements the ElectrolyzerInput interface.
 */
export function instanceOfElectrolyzerInput(value: object): value is ElectrolyzerInput {
    return true;
}

export function ElectrolyzerInputFromJSON(json: any): ElectrolyzerInput {
    return ElectrolyzerInputFromJSONTyped(json, false);
}

export function ElectrolyzerInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElectrolyzerInput {
    if (json == null) {
        return json;
    }
    return {
        
        'no': json['no'] == null ? undefined : json['no'],
        'electrolyzer': json['electrolyzer'] == null ? undefined : json['electrolyzer'],
        'operate': json['operate'] == null ? undefined : json['operate'],
        'cells': json['cells'] == null ? undefined : json['cells'],
        'current': json['current'] == null ? undefined : json['current'],
        'voltage': json['voltage'] == null ? undefined : json['voltage'],
        'temp': json['temp'] == null ? undefined : json['temp'],
        'currentEfficiency': json['currentEfficiency'] == null ? undefined : json['currentEfficiency'],
        'rangeMax': json['rangeMax'] == null ? undefined : json['rangeMax'],
        'rangeMin': json['rangeMin'] == null ? undefined : json['rangeMin'],
        'naohProduction': json['naohProduction'] == null ? undefined : json['naohProduction'],
        'naclInNaoh50': json['naclInNaoh50'] == null ? undefined : json['naclInNaoh50'],
        'pc': json['pc'] == null ? undefined : json['pc'],
    };
}

export function ElectrolyzerInputToJSON(value?: ElectrolyzerInput | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'no': value['no'],
        'electrolyzer': value['electrolyzer'],
        'operate': value['operate'],
        'cells': value['cells'],
        'current': value['current'],
        'voltage': value['voltage'],
        'temp': value['temp'],
        'currentEfficiency': value['currentEfficiency'],
        'rangeMax': value['rangeMax'],
        'rangeMin': value['rangeMin'],
        'naohProduction': value['naohProduction'],
        'naclInNaoh50': value['naclInNaoh50'],
        'pc': value['pc'],
    };
}

